var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-list-item",
        _vm._g(
          { style: { "background-color": _vm.rigaHeaderStyle } },
          _vm.hasVariazioni ? { click: _vm.toggleshowVariazioni } : {}
        ),
        [
          _c(
            "v-list-item-content",
            [
              _c(
                "v-list-item-title",
                [
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.riga.codiceTipoFilato) +
                        " - " +
                        _vm._s(_vm.riga.descrizioneTipoFilato)
                    ),
                  ]),
                  _vm.hasVariazioni
                    ? _c(
                        "v-icon",
                        {
                          class: { "active-expansion": _vm.showVariazioni },
                          staticStyle: { "margin-left": "10px" },
                        },
                        [_vm._v(" mdi-chevron-down")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-list-item-subtitle",
                [
                  _vm.hasVariazioni
                    ? _c("span", { staticStyle: { color: "rgb(251 68 68)" } }, [
                        _c("strong", [_vm._v("SONO PRESENTI VARIAZIONI")]),
                        _c("br"),
                      ])
                    : _vm._e(),
                  _vm._v(" Quantità: "),
                  _c("br"),
                  _c("strong", [_vm._v(_vm._s(_vm.riga.quantitaCapiOrdine))]),
                  _c("br"),
                  _c("br"),
                  _vm._v(" Stato: "),
                  _c("strong", [_vm._v(_vm._s(_vm.riga.stato))]),
                  _vm._v(", Taglia: "),
                  _c("strong", [_vm._v(_vm._s(_vm.riga.codiceTaglia))]),
                  _vm._v(", Stagione: "),
                  _c("strong", [_vm._v(_vm._s(_vm.riga.stagione))]),
                  _vm._v(", Linea vendita: "),
                  _c("strong", [_vm._v(_vm._s(_vm.riga.lineaVendita))]),
                  _vm._v(", Modello anagrafico: "),
                  _c("strong", [_vm._v(_vm._s(_vm.riga.modelloAnagrafico))]),
                  _vm._v(", Modifica produzione: "),
                  _c("strong", [_vm._v(_vm._s(_vm.riga.modificaProduzione))]),
                  _c("br"),
                  _vm._v(" Articolo: "),
                  _c("strong", [_vm._v(_vm._s(_vm.riga.articolo))]),
                  _vm._v(", Tessuto: "),
                  _c("strong", [_vm._v(_vm._s(_vm.riga.tessuto))]),
                  _vm._v(", Codice Colore: "),
                  _c("strong", [_vm._v(_vm._s(_vm.riga.codiceColore))]),
                  _vm._v(", Colore Tessuto: "),
                  _c("strong", [_vm._v(_vm._s(_vm.riga.coloreTessuto))]),
                  _vm._v(", Colore Fodera: "),
                  _c("strong", [_vm._v(_vm._s(_vm.riga.coloreFodera))]),
                  _vm._v(", Colore Bottoni: "),
                  _c("strong", [_vm._v(_vm._s(_vm.riga.coloreBottoni))]),
                  _c("br"),
                  _vm.riga.giaccaPant
                    ? _c("span", [
                        _vm._v(
                          "Giacca/Pantalone: " + _vm._s(_vm.riga.giaccaPant)
                        ),
                      ])
                    : _vm._e(),
                  _vm.riga.giaccaPant ? _c("br") : _vm._e(),
                  _vm.riga.primaProvaTelaCapoFinito
                    ? _c("span", [
                        _vm.riga.primaProvaTelaCapoFinito == "P"
                          ? _c("span", [_vm._v("PRIMA PROVA")])
                          : _vm._e(),
                        _vm.riga.primaProvaTelaCapoFinito == "T"
                          ? _c("span", [_vm._v("TELA")])
                          : _vm._e(),
                        _vm.riga.primaProvaTelaCapoFinito == "F"
                          ? _c("span", [_vm._v("CAPO FINITO")])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _c("br"),
                  _vm._l(_vm.riga.idLidAssociate, function (idLidAssociata) {
                    return _c(
                      "div",
                      [
                        _c("br"),
                        idLidAssociata
                          ? _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "riga",
                                    params: { id: idLidAssociata },
                                  },
                                },
                              },
                              [
                                idLidAssociata == _vm.idLidAssociataCorrente
                                  ? _c("strong", [
                                      _vm._v(
                                        "LAVORAZIONE: " + _vm._s(idLidAssociata)
                                      ),
                                    ])
                                  : _c("div", [
                                      _vm._v(
                                        "LAVORAZIONE: " + _vm._s(idLidAssociata)
                                      ),
                                    ]),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  _vm.riga.note
                    ? _c("div", [
                        _c("br"),
                        _c("strong", [_vm._v("Note: ")]),
                        _vm._v(_vm._s(_vm.riga.note)),
                      ])
                    : _vm._e(),
                  _c("br"),
                  _c(
                    "div",
                    [
                      _vm.riga.dataConsegnaFornitore
                        ? _c("span", { staticStyle: { color: "#855b5b" } }, [
                            _vm._v(" Data consegna fornitore: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatDate")(
                                    _vm.riga.dataConsegnaFornitore
                                  )
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _c("span"),
                      !_vm.guiRigheMtmModificaDati
                        .inModificaNoteConsegnaOrdineFornitore
                        ? _c(
                            "strong",
                            {
                              staticStyle: { color: "#855b5b" },
                              style: _vm.riga.dataConsegnaFornitore
                                ? "margin-left:10px"
                                : "",
                            },
                            [_vm._v("Note di consegna: ")]
                          )
                        : _vm._e(),
                      !_vm.guiRigheMtmModificaDati
                        .inModificaNoteConsegnaOrdineFornitore
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.riga.noteConsegna || "")),
                          ])
                        : _vm._e(),
                      !_vm.guiRigheMtmModificaDati
                        .inModificaNoteConsegnaOrdineFornitore
                        ? _c(
                            "v-btn",
                            {
                              attrs: { text: "", ripple: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.modificaNoteConsegnaOrdineFornitore(
                                    _vm.riga
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: { small: "", color: "grey lighten-1" },
                                },
                                [_vm._v("mdi-pencil")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.guiRigheMtmModificaDati
                        .inModificaNoteConsegnaOrdineFornitore
                        ? _c(
                            "v-flex",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "8" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "hide-details": "",
                                          dense: "",
                                          filled: "",
                                          clearable: "",
                                          label: "Note di consegna",
                                        },
                                        model: {
                                          value:
                                            _vm.guiRigheMtmModificaDati
                                              .noteConsegnaModifica,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.guiRigheMtmModificaDati,
                                              "noteConsegnaModifica",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "guiRigheMtmModificaDati.noteConsegnaModifica",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    [
                                      _c(
                                        "v-card-actions",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "darken-1",
                                                text: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  _vm.guiRigheMtmModificaDati.inModificaNoteConsegnaOrdineFornitore = false
                                                },
                                              },
                                            },
                                            [_vm._v("Annulla")]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "green darken-1",
                                                text: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.inviaNoteConsegnaRigaMtm(
                                                    _vm.riga
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Salva")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.riga.dataChiusuraConsegna
                    ? _c("span", { staticStyle: { color: "#855b5b" } }, [
                        _vm._v(" Data ordine di lancio: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatDate")(
                                _vm.riga.dataChiusuraConsegna
                              )
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.riga.dataConsegnaFornitore ||
                  _vm.riga.dataComunicazioneAggiornamentoFornitore
                    ? _c("br")
                    : _vm._e(),
                  _vm.riga.dataComunicazioneAggiornamentoFornitore
                    ? _c("small", { staticStyle: { color: "#3f8fd0" } }, [
                        _vm._v(
                          " inviato aggiornamento il " +
                            _vm._s(
                              _vm._f("formatDate")(
                                _vm.riga.dataComunicazioneAggiornamentoFornitore
                              )
                            ) +
                            " alle " +
                            _vm._s(
                              _vm._f("formatTime")(
                                _vm.riga.dataComunicazioneAggiornamentoFornitore
                              )
                            ) +
                            " per nuovo valore “"
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm._f("formatDate")(
                                _vm.riga.dataConsegnaFornitoreDaAggiornareAs400
                              )
                            )
                          ),
                        ]),
                        _vm._v(
                          "“ della data consegna fornitore, in attesa di sincronizzazione con AS-400. "
                        ),
                      ])
                    : _vm._e(),
                  _vm.riga.idOrdineFornitore ? _c("br") : _vm._e(),
                  _vm.riga.idOrdineFornitore
                    ? _c("span", { staticStyle: { color: "#855b5b" } }, [
                        _vm._v(" Id ordine fornitore: "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.riga.idOrdineFornitore)),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.riga.dataComunicazioneAggiornamentoFornitore
                    ? _c("small", { staticStyle: { color: "#3f8fd0" } }, [
                        _vm._v(
                          " inviato aggiornamento il " +
                            _vm._s(
                              _vm._f("formatDate")(
                                _vm.riga.dataComunicazioneAggiornamentoFornitore
                              )
                            ) +
                            " alle " +
                            _vm._s(
                              _vm._f("formatTime")(
                                _vm.riga.dataComunicazioneAggiornamentoFornitore
                              )
                            ) +
                            " per nuovo valore “"
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.riga.idOrdineFornitoreDaAggiornareAs400)
                          ),
                        ]),
                        _vm._v(
                          "“ dell'id ordine fornitore, in attesa di sincronizzazione con AS-400. "
                        ),
                      ])
                    : _vm._e(),
                  _vm.riga.dataComunicazioneAggiornamentoFornitore ||
                  _vm.riga.idOrdineFornitore
                    ? _c("br")
                    : _vm._e(),
                  _vm.guiRigheMtmModificaDati.inModificaOrdineFornitore
                    ? _c(
                        "span",
                        [
                          _c("v-spacer"),
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    [
                                      _c("DatePicker", {
                                        attrs: {
                                          textBoxLabel:
                                            "Nuova data consegna fornitore",
                                          hide_details: true,
                                        },
                                        model: {
                                          value:
                                            _vm.guiRigheMtmModificaDati
                                              .dataConsegnaFornitore,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.guiRigheMtmModificaDati,
                                              "dataConsegnaFornitore",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "guiRigheMtmModificaDati.dataConsegnaFornitore",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "hide-details": "",
                                          dense: "",
                                          filled: "",
                                          clearable: "",
                                          label: "Nuovo id ordine fornitore",
                                        },
                                        model: {
                                          value:
                                            _vm.guiRigheMtmModificaDati
                                              .idOrdineFornitore,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.guiRigheMtmModificaDati,
                                              "idOrdineFornitore",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "guiRigheMtmModificaDati.idOrdineFornitore",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-card-actions",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "darken-1", text: "" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      _vm.guiRigheMtmModificaDati.inModificaOrdineFornitore = false
                                    },
                                  },
                                },
                                [_vm._v("Annulla")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "green darken-1", text: "" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.inviaDatiOrdineConsegnaRigaMtm(
                                        _vm.riga
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Salva")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showInviaAggiornamentoButton
                    ? _c(
                        "div",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", ripple: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.modificaOrdineFornitore(_vm.riga)
                                },
                              },
                            },
                            [
                              _vm._v(" INVIA AGGIORNAMENTO "),
                              _c(
                                "v-icon",
                                {
                                  attrs: { small: "", color: "grey lighten-1" },
                                },
                                [_vm._v("mdi-pencil")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showVariazioni ? _c("v-divider") : _vm._e(),
      _vm.showVariazioni
        ? _c(
            "v-list-item",
            { style: { "background-color": "#f2f2f2" } },
            [
              (_vm.riga.variazioni || []).length > 0 && _vm.showVariazioni
                ? _c(
                    "v-list",
                    { staticClass: "selection-list" },
                    [
                      _vm._l(_vm.riga.variazioni, function (variazione, i) {
                        return [
                          _c("ItemListVariazioneOrdineMTM", {
                            key: variazione.id,
                            attrs: { variazione: variazione },
                            on: {
                              "conferma-variazione": _vm.confermaVariazione,
                            },
                          }),
                          i < _vm.riga.variazioni.length - 1
                            ? _c("v-divider")
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }